module.exports = __webpack_public_path__ + "static/media/level1_mod.b169408b.png";